import { Pipe, PipeTransform } from '@angular/core';
import type { ProductMenu } from '../../../models/menu/product-menu';

@Pipe({
  name: 'productMenuBasicMethod',
  standalone: false
})
export class ProductMenuBasicMethodPipe implements PipeTransform {
  /**
   * @deprecated use MethodPipe instead
   */
  transform(productMenu: ProductMenu, methodKey: string, ...args: any[]): any {
    return productMenu?.[methodKey]?.(...args);
  }
}
